import { useState, useEffect } from "react";
import { Col } from "react-bootstrap";
import AnimatedSelect from "../../../shared/AnimatedSelect";
import "../../../shared/AnimatedSelect.css";

const PartnerCategoryFilters = ({ filterValues = {}, partnerCategories = [], onFilterChange }) => {
  // Initialize as array for multiselect
  const getInitialValue = () => {
    if (filterValues.partnerCategory != null) {
      return Array.isArray(filterValues.partnerCategory) 
        ? filterValues.partnerCategory 
        : [filterValues.partnerCategory];
    }
    return [];
  };
  
  const [selectedCategory, setSelectedCategory] = useState(getInitialValue());

  // Keep local UI state in sync when parent provides prefilled values
  useEffect(() => {
    if (filterValues.partnerCategory != null) {
      const newValue = Array.isArray(filterValues.partnerCategory) 
        ? filterValues.partnerCategory 
        : [filterValues.partnerCategory];
      setSelectedCategory(newValue);
    } else {
      setSelectedCategory([]);
    }
  }, [filterValues.partnerCategory]);

  return (
    <>
      <Col className="custom_col">
        <AnimatedSelect
          value={filterValues.hasDone || "Include"}
          options={[
            { label: "Include", value: "Include" },
            { label: "Exclude", value: "Exclude" }
          ]}
          onChange={(value) => onFilterChange && onFilterChange("hasDone", value)}
        />
      </Col>
      <Col className="custom_col">
        <AnimatedSelect
          multiple={true}
          maxDisplayItems={5}
          value={selectedCategory}
          options={[
            { label: "All Partners", value: "All" },
            ...partnerCategories.map((item) => ({
              label: item.name,
              value: item.id
            }))
          ]}
          onChange={(value) => {
            const currentValue = Array.isArray(value) ? value : [];
            const allCategoryIds = partnerCategories.map(item => String(item.id));
            const wasAllSelected = Array.isArray(selectedCategory) && selectedCategory.includes("All");
            const isAllSelected = currentValue.includes("All");
            
            // Get currently selected category IDs (excluding "All")
            const selectedIds = currentValue.filter(v => v !== "All").map(String);
            
            if (isAllSelected && !wasAllSelected) {
              // "All Partners" was just checked - select all categories
              const allValues = ["All", ...allCategoryIds];
              setSelectedCategory(allValues);
              // Send only category IDs to payload, exclude "All"
              onFilterChange && onFilterChange("partnerCategory", allCategoryIds);
            } else if (!isAllSelected && wasAllSelected) {
              // "All Partners" was just unchecked - uncheck all
              setSelectedCategory([]);
              onFilterChange && onFilterChange("partnerCategory", []);
            } else if (!isAllSelected) {
              // Individual categories are being selected/deselected
              // Check if all categories are now selected
              const allSelected = allCategoryIds.length > 0 && 
                allCategoryIds.every(id => selectedIds.includes(id));
              
              if (allSelected) {
                // All categories selected - automatically check "All Partners"
                const newValue = ["All", ...allCategoryIds];
                setSelectedCategory(newValue);
                // Send only category IDs to payload, exclude "All"
                onFilterChange && onFilterChange("partnerCategory", allCategoryIds);
              } else {
                // Not all categories selected - just update with current selection
                setSelectedCategory(selectedIds);
                // Send only category IDs to payload, exclude "All"
                onFilterChange && onFilterChange("partnerCategory", selectedIds);
              }
            }
          }}
        />
      </Col>      
    </>
  );
};

export default PartnerCategoryFilters;

